const langlist = {
  hiraganaerror: '全角ひらがなでご入力ください。',
  telerror: '電話番号を正しくご入力ください。',
  telcharerror: '電話番号は半角数字でハイフンを含めずにご入力ください。',
  tellengtherror: '電話番号は10桁もしくは11桁でご入力ください。',
  mobtellengtherror: '電話番号は11桁でご入力ください。',
  確認: '同意して次へ',
  確認2: '同意して申し込む',
};

module.exports = langlist;
